import { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import BinanceUsers from "components/BinanceUsers";
import BinanceUserModal from "components/BinanceUsers/BinanceUserModal";
import { getBinanceUsers } from "api/settings";
import { UseUserEditSettings } from "api/user";

import NoAccess from "components/Util/NoAccess";

export default function Settings() {
  const { user } = useAuth0();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [binanceUsers, setBinanceUsers] = useState([]);
  const [editSettings, setEditSettings] = useState(false);

  const updateBinanceUsers = useCallback(() => {
    getBinanceUsers(
      user["https://hasura.io/jwt/claims"]["x-hasura-user-id"]
    ).then(({ data }) => {
      if (typeof data !== "undefined") {
        setBinanceUsers(data.settings);
      }
    });
  }, [user]);

  useEffect(() => {
    updateBinanceUsers();

    return () => setBinanceUsers([]);
  }, [updateBinanceUsers]);


  useEffect(() => {
    UseUserEditSettings(
      user["https://hasura.io/jwt/claims"]["x-hasura-user-id"],
      sessionStorage.getItem("farm_name")
    ).then((details: any) => {
      if (typeof details !== "undefined") {
        setEditSettings(details.data.users_settings[0].edit_settings);
      }
    });
  }, [user, editSettings]);

  const closeAddModal = () => {
    setIsAddOpen(false);
    updateBinanceUsers();
  };

  const openAddModal = () => {
    setIsAddOpen(true);
  };

  return (
    <div className="p-6">
      {editSettings ?
        <section className="bg-white pt-5 pb-5 rounded-sm sm:overflow-hidden">
          <div className="flex justify-between items-center px-4 sm:px-6">
            <h2 className="text-lg leading-6 font-medium text-gray-600">
              Binance Info
            </h2>
            <button
              type="button"
              className="form-input inline-flex items-center border border-transparent leading-4 font-medium shadow-sm text-white focus:outline-none bg-blue-600 hover:bg-blue-700 rounded-sm px-4 py-2 text-sm"
              onClick={openAddModal}
            >
              Edit
            </button>
            <BinanceUserModal isOpen={isAddOpen} onClose={closeAddModal} />
          </div>
        </section>
        :
        <NoAccess />
      }
    </div>
  );
}
